export default __webpack_public_path__ + "static/media/bestSP.af2d48f5.png";